import { FormControl, MenuItem, Select, InputLabel } from '@material-ui/core'
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { physicalPerson } from './DatabaseObjectFields/PhysicalPerson'
import { sas } from './DatabaseObjectFields/SAS'
import { moralPerson } from './DatabaseObjectFields/MoralPerson'
import {
  ensureMappingStructure,
  ensureMappingDataElement,
  getMappingValue,
  initializeUnisignMapping
} from '../../../utils/databaseMapping'

export default ({
  variableDialog,
  setvariableDialog,
  elementKey,
  tabValue,
  mappingModels: propMappingModels,
}) => {
  const [loading, setLoading] = useState(true)
  const [mappingModelsState, setMappingModelsState] = useState({})

  useEffect(() => {
    setLoading(true)
    const obj = { ...propMappingModels }
    obj[physicalPerson.name] = physicalPerson.fields
    obj[sas.name] = sas.fields
    obj[moralPerson.name] = moralPerson.fields
    setMappingModelsState(obj)
    setLoading(false)
  }, [propMappingModels])

  // Initialize structure based on variable type
  useMemo(() => {
    if (variableDialog.type === 'multiarray') {
      ensureMappingDataElement(variableDialog, +tabValue - 1, elementKey)
    } else if (variableDialog.type === 'unisign' || variableDialog.type === 'multisign') {
      initializeUnisignMapping(variableDialog)
    } else {
      // For other types, ensure basic structure
      ensureMappingDataElement(variableDialog, +tabValue - 1, elementKey)
    }
  }, [variableDialog.type, tabValue, elementKey])

  // Memoize current value for performance
  const currentValue = useMemo(() => {
    return getMappingValue(variableDialog, +tabValue - 1, elementKey)
  }, [variableDialog, tabValue, elementKey])

  // Memoize fields for performance
  const fields = useMemo(() => {
    if (variableDialog.type === 'multiarray') {
      const mapping = variableDialog.database_object_model_fields_mapping?.[+tabValue - 1]
      if (!mapping) return []
      return mappingModelsState[mapping.database_object_model_name]?.map((el) => (
        <MenuItem value={el}>{el}</MenuItem>
      )) || []
    }
    return []
  }, [variableDialog, tabValue, mappingModelsState])

  const handleChange = useCallback((e) => {
    let result = { ...variableDialog }

    if (result.type === 'unisign' || result.type === 'multisign') {
      if (elementKey === 0) {
        const mapping = ensureMappingStructure(result, 0)
        mapping.database_object_model_name = e.target.value
        result.database_object_model_name = e.target.value
      } else if (elementKey === 1) {
        ensureMappingDataElement(result, 0, 1).database_object_model_field_name = e.target.value
        ensureMappingDataElement(result, 0, 1).variable_field_name = 'email'
      } else if (elementKey === 2) {
        ensureMappingDataElement(result, 0, 2).database_object_model_field_name = e.target.value
        ensureMappingDataElement(result, 0, 2).variable_field_name = 'email'
      }
    } else if (result.type === 'multiarray') {
      ensureMappingDataElement(result, tabValue - 1, elementKey).database_object_model_field_name = e.target.value
      ensureMappingDataElement(result, tabValue - 1, elementKey).variable_field_name = result.options[tabValue - 1][elementKey].label
    } else if (result.type === 'object') {
      ensureMappingDataElement(result, tabValue - 1, elementKey).database_object_model_field_name = e.target.value
      ensureMappingDataElement(result, tabValue - 1, elementKey).variable_field_name = result.options[elementKey].label
    } else {
      ensureMappingDataElement(result, tabValue - 1, elementKey).database_object_model_field_name = e.target.value
      ensureMappingDataElement(result, tabValue - 1, elementKey).variable_field_name = ''
    }

    setvariableDialog(result)
  }, [variableDialog, setvariableDialog, elementKey, tabValue])

  return (
    <FormControl size="small" style={{ width: 200, backgroundColor: 'white' }} variant="outlined">
      <InputLabel>Modèle d'objet</InputLabel>
      <Select
        label="Modèle d'objet"
        value={currentValue}
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>Aucun</em>
        </MenuItem>
        {!loading && fields}
      </Select>
    </FormControl>
  )
}
